import type { ReactElement } from 'react';

import { detectEnvironment } from '@/shared/lib/detectEnvironment';

import { HubspotTrackingLister } from './components/HubspotTrackingLister';
import { PostHogTrackingListener } from './components/PostHogTrackingListener';

export const TrackingLister = ({ children }: { children: ReactElement }) => {
  if (detectEnvironment() === 'local') return children;
  return (
    <HubspotTrackingLister>
      <PostHogTrackingListener>{children}</PostHogTrackingListener>
    </HubspotTrackingLister>
  );
};
